import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import { colors, typography } from '../styles';

const styles = css`
  padding: 30px 0;
  margin: 0;
  @media (min-width: 992px) {
    padding: 90px 0;
  }
  .row {
    flex-direction: column-reverse;
    @media (min-width: 992px) {
      flex-direction: row;
    }
  }
  .PageIntroBanner_headline {
    text-align: center;
    font-family: ${typography.Serif};
    font-size: 24px;
    margin-bottom: 20px;
    font-weight: 400;
    color: ${colors.color1Dark};
    position: relative;
    margin: 0 0 45px 0;
    &:after {
      content: '';
      position: absolute;
      display: block;
      left: calc(50% - 30px);
      bottom: -26px;
      width: 60px;
      height: 3px;
      background-color: ${colors.color2};
    }
    @media (min-width: 992px) {
      font-size: 36px;
    }
  }
  .PageIntroBanner_body {
    font-weight: 400;
    font-size: 18px;
    color: ${colors.color1};
    line-height: 2;
    text-align: center;
    padding: 0 30px;
    @media (min-width: 992px) {
      font-size: 21px;
      padding: 0;
    }
  }
  .PageIntroBanner_image {
    position: relative;
    overflow: hidden;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    img {
      width: 100%;
      height: auto;
      @media (min-width: 992px) {
        margin: 0;
      }
    }
  }
`;

function PageIntroBanner({ headline, body }) {
  return (
    <div className={styles}>
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-8 mx-auto">
            <h2 className="PageIntroBanner_headline">{headline}</h2>
            <div className="PageIntroBanner_body">{body}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

PageIntroBanner.propTypes = {
  headline: PropTypes.string,
  body: PropTypes.string,
};

PageIntroBanner.defaultProps = {
  headline: undefined,
  body: undefined,
};

export default PageIntroBanner;



// WEBPACK FOOTER //
// ./src/components/PageIntroBanner.js